/**
 * Where to fetch the attachment binary. The BE serves blobs from the
 * tenant-scoped `/attachments/{id}` endpoint regardless of which person
 * owns them, so we ignore the row's `filePath` (which used to point to
 * the now-retired person-scoped path).
 */
export function buildAttachmentDownloadUrl(attachmentId: string): string {
  return `/attachments/${encodeURIComponent(attachmentId)}`;
}
